'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventResultRoutes = [
  {
    path: 'results',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.result.list',
        props: true,
        component: () => import('../views/ResultListView.vue'),
      },
      {
        path: 'sectors',
        name: 'event.result.sector',
        props: true,
        component: () => import('../views/ResultSectorView.vue'),
      },
      {
        path: ':sessionNumber',
        name: 'event.result.group',
        props: true,
        component: () => import('../views/ResultGroupView.vue'),
      },
      // {
      //   path: ':resultId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.result.detail',
      //       component: () => import('../views/ResultDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageResultRoutes = [
  {
    path: 'results',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.result.list',
        props: true,
        component: () => import('../views/ManageResultListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.result.add',
        props: (route) => ({
          eventUrl: route.params.eventUrl,
          group: route.query.group,
          session: parseInt(route.query.session),
        }),
        component: () => import('../views/ManageResultAddView.vue'),
      },
      {
        path: ':sessionNumber',
        name: 'event.manage.result.group',
        props: true,
        component: () => import('../views/ManageResultGroupView.vue'),
      },

      // {
      //   path: ':sessionNumber',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     // {
      //     //   path: '',
      //     //   name: 'event.manage.result.detail',
      //     //   props: true,
      //     //   component: () => import('../views/ManageResultDetailView.vue'),
      //     // },
      //     {
      //       path: 'session',
      //       name: 'event.manage.result.session',
      //       props: true,
      //       component: () => import('../views/ionView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];
